import { colors } from "../../../../utils";

/**
 * Colour pairs for the builder's shared tab strip (CustomTabs).
 *
 * Kelly's QA-50 video (2026-08-01) reported the Wheel Settings "Design" and
 * "Access" tabs as reading DISABLED. Measured live on web-stg (bundle
 * main.c8f0dfa9.js): they are not disabled at all — `disabled=false`,
 * `aria-disabled=null`, `cursor:pointer`, `pointer-events:auto`, and clicking
 * either one swaps the panel. What is wrong is the colour: the inactive label
 * was `colors.lightGrey` (#BBBBBB) on `colors.background` (#F6F7F9), which
 * measures 1.78:1 — far below the 4.5:1 WCAG-AA floor for 14px text, and low
 * enough that a working control reads as a dead one.
 *
 * Re-measuring the strip turned up a second failure the video did not name:
 * the ACTIVE label used `colors.PrimaryPurple` (#9B5AF8) on the
 * `PrimaryPurple100` (#EFE9FE) selected fill, which is 3.30:1 and also fails.
 * The repo already has the answer for purple-on-tint — `PrimaryPurple700`,
 * documented in the palette as the on-tint step — so both states move onto
 * tokens that clear AA. This mirrors the existing `PrimaryGreenDark` fix, which
 * was added for exactly this reason on the green status tint.
 *
 * Values live here, apart from the component, so the contrast is assertable
 * without mounting MUI's TabList.
 */
export const TAB_INACTIVE_BG = colors.background; // #F6F7F9
export const TAB_ACTIVE_BG = colors.PrimaryPurple100; // #EFE9FE

export const TAB_INACTIVE_TEXT = colors.textGrey; // #6B6F80 — 4.63:1 on #F6F7F9
export const TAB_ACTIVE_TEXT = colors.PrimaryPurple700; // #8126DB — 5.49:1 on #EFE9FE

/** The pre-fix values, kept so the regression test can prove they failed. */
export const PRE_FIX_INACTIVE_TEXT = "#BBBBBB";
export const PRE_FIX_ACTIVE_TEXT = "#9B5AF8";
